import { createApiInstance } from "./apiClient";

const orderUrl = process.env.REACT_APP_ORDER_API_URL;

export const postCheckout = async (items) => {
	try {
		const instance = createApiInstance({ baseURL: `${orderUrl}/api/checkout/`, retry: true });

		const itemsBody = items.map(item => {
			return {
				sku: item.sku,
				quantity: item.quantity
			};
		});

		const body = { items: itemsBody };

		return await instance
			.post(``, body)
			.then((response) => {
				if (response.status === 200)
					return {
						error: false,
						success: true,
						message: response.data.message,
						data: response.data.data
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}
			});
	}
	catch (error) {
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};

export const putCheckout = async (checkoutData) => {
	try {
		const instance = createApiInstance({ baseURL: `${orderUrl}/api/checkout/`, retry: true });

		if (!!checkoutData?.orderItems && checkoutData.orderItems === "null") {
			checkoutData.orderItems = null;
		}

		const requestUrl = ``;
		return await instance
			.put(requestUrl, checkoutData)
			.then((response) => {
				if (response.status === 200 || response.status === 204)
					return {
						error: false,
						success: true,
						message: response.data.message,
						data: response.data.data
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}
			});
	}
	catch (error) {
		console.error(error);
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};

export const putReactivateCheckout = async (orderId) => {
	try {
		const instance = createApiInstance({ baseURL: `${orderUrl}/api/checkout/`, retry: true });


		const requestUrl = ``;
		return await instance
			.put(requestUrl, checkoutData)
			.then((response) => {
				if (response.status === 200 || response.status === 204)
					return {
						error: false,
						success: true,
						message: response.data.message,
						data: response.data.data
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}
			});
	}
	catch (error) {
		console.error(error);
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};

export const getCheckoutData = async () => {
	try {
		const instance = createApiInstance({ baseURL: `${orderUrl}/api/checkout`, retry: true });

		const requestUrl = "";
		return await instance
			.get(requestUrl)
			.then((response) => {
				if (response.status === 200)
					return {
						error: false,
						success: true,
						message: response.data.message,
						data: response.data.data
					};
				else if (response.status === 204)
					return {
						error: false,
						success: true,
						message: "no checkout session found"
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}
			});
	}
	catch (e) {
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};

export const getAddressCheckoutData = async () => {
	try {
		const instance = createApiInstance({ baseURL: `${orderUrl}/api/checkout`, retry: true });

		const requestUrl = `/address`;
		return await instance
			.get(requestUrl)
			.then((response) => {
				if (response.status === 200)
					return {
						error: false,
						success: true,
						message: response.data.message,
						data: response.data.data
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}
			});
	}
	catch (e) {
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};

export const getOrderCheckoutData = async () => {
	try {
		const instance = createApiInstance({ baseURL: `${orderUrl}/api/checkout`, retry: true });

		const requestUrl = "/order";
		return await instance
			.get(requestUrl)
			.then((response) => {
				if (response.status === 200)
					return {
						error: false,
						success: true,
						message: response.data.message,
						data: response.data.data
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}
			});
	}
	catch (e) {
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};
